import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/utils/cn'

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('rounded-card border border-line bg-surface shadow-card', className)} {...props} />
  )
}

interface CardHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  description?: ReactNode
  icon?: ReactNode
  actions?: ReactNode
}

export function CardHeader({ title, description, icon, actions, className, ...props }: CardHeaderProps) {
  return (
    <div
      className={cn('flex flex-wrap items-center gap-3 border-b border-line px-5 py-4', className)}
      {...props}
    >
      {icon ? (
        <span className="grid size-9 shrink-0 place-items-center rounded-control bg-brand-50 text-brand-600 [&_svg]:size-[1.125rem]">
          {icon}
        </span>
      ) : null}
      <div className="min-w-48 flex-1">
        <h2 className="text-[0.9375rem] font-semibold">{title}</h2>
        {description ? <p className="mt-0.5 text-xs text-muted">{description}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  )
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-5', className)} {...props} />
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-end gap-2 rounded-b-card border-t border-line bg-surface-muted/60 px-5 py-3.5',
        className,
      )}
      {...props}
    />
  )
}
